import React, { useEffect, useRef, useState } from 'react';
import { TextField } from '@gerdau/hefesto/TextField';
import { OrderItemWrapper } from './styles';
// order item input field
interface IOrderItemInputProps {
  orderItemInput?: number;
  setOrderItemInput(value?: number): void;
  maxLengthInput: number;
  warnings?: IWarnings;
}

interface IWarnings {
  isError?: boolean;
  isEmpty?: boolean;
}

const OrderItemInputTable: React.FC<IOrderItemInputProps> = ({
  orderItemInput,
  setOrderItemInput,
  maxLengthInput,
  warnings
}) => {
  const [orderItemInputState, setInputValue] = useState(orderItemInput);
  const [warningsState, setWarningsState] = useState(warnings);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setInputValue(orderItemInput);
  }, [orderItemInput]);

  useEffect(() => {
    setOrderItemInput(orderItemInputState);
  }, [orderItemInputState]);

  useEffect(() => {
    setWarningsState(warnings);
  }, [warnings]);

  useEffect(() => {
    removeHefestoElements();
  }, [warningsState]);

  const removeHefestoElements = () => {
    const classTextField = 'hefesto-textfield';
    const icon = 'hefesto-textfield__right-icon';
    const iconClass = 'hefesto-textfield--icon-right';

    const textFields = elementRef.current?.querySelectorAll(
      `.${classTextField}`
    );
    textFields?.forEach((el) => el.classList.remove(iconClass));
    const inputIcons = elementRef.current?.querySelectorAll(`.${icon}`);
    inputIcons?.forEach((el) => el.remove());
  };

  const updateInputValue = (value: string) => {
    const preValue = Number(value);
    if (!isNaN(preValue)) {
      setInputValue(value === undefined || value === '' ? undefined : preValue);
    }
  };

  return (
    <OrderItemWrapper ref={elementRef}>
      <TextField
        maxLength={maxLengthInput}
        label=""
        hideLabel
        name="orderItemInput"
        value={orderItemInputState}
        variant={
          warningsState?.isEmpty || warningsState?.isError
            ? warningsState.isError
              ? 'danger'
              : 'warning'
            : undefined
        }
        onChange={(e) => updateInputValue(e.target.value)}
      />
    </OrderItemWrapper>
  );
};

export default OrderItemInputTable;
